/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_SubmitInputs */

const en_consult_submit = /** @type {(inputs: Consult_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const id_consult_submit = /** @type {(inputs: Consult_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim`)
};

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Consult_SubmitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_submit = /** @type {((inputs?: Consult_SubmitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_SubmitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_submit(inputs)
	return en_consult_submit(inputs)
});